import { WithoutId } from './utils'

export type LatLngLiteral = {
  lat: number
  lng: number
}

export type LatLngTuple = [number, number]
export type LngLatTuple = [number, number]

export type LatLngBoundsLiteral = LatLngTuple[]

export enum BalladType {
  HIKE = 'hike',
  RIDE = 'ride',
}

export type Ballad = {
  _id: string
  slug: string
  name: string
  type: BalladType
  distance?: number
  loop: boolean
  draft: boolean
  track?: string
  publicTransportStartIds?: string[]
  publicTransportEndIds?: string[]
}

export function isExistingBallad(
  ballad: Ballad | WithoutId<Ballad>
): ballad is Ballad {
  return ballad.hasOwnProperty('_id') === true
}

export type Gpx = {
  _id: string
  ballads?: string[]
  filename: string
  name: string
  date: string
  type: BalladType
}
